import { ProfileRepresentation } from "@sista/library-stasi";
import { TFunction } from "i18next";

/** Pravo (vazbator) spravovat zastupy zamestnancu poskytovatele, v kontextu poskytovatele. */
export const REPRESENTATION_MANAGE_PERMISSION =
  "rejstrik:representation-manage";

export const providerUrn = (providerId: string) =>
  "urn:sista:providers:" + providerId;

export const urnEntityId = (urn: string) => urn.split(":").slice(3).join(":");

const isMidnight = (d: Date) =>
  d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0;

const formatDateTime = (d: Date) =>
  d.toLocaleString("cs-CZ", { dateStyle: "short", timeStyle: "short" });

/**
 * Zastup zadany po dnech (oba konce o pulnoci) se ukazuje po dnech a konec jako posledni den
 * (konec je pulnoc po nem), jinak oba konce i s casem.
 */
export const formatRepresentationPeriod = (r: ProfileRepresentation) => {
  const from = new Date(r.from);
  const to = r.to ? new Date(r.to) : undefined;
  if (isMidnight(from) && (!to || isMidnight(to))) {
    return (
      from.toLocaleDateString("cs-CZ") +
      " – " +
      (to ? new Date(to.getTime() - 1).toLocaleDateString("cs-CZ") : "")
    );
  }
  return formatDateTime(from) + " – " + (to ? formatDateTime(to) : "");
};

/** Kde rozpracovana zadost o zastup (workflow provider_substitution) stoji - pro zastupovaneho. */
export const pendingRepresentationInfo = (
  t: TFunction,
  r: ProfileRepresentation
) => {
  const params = {
    name: r.substituteDisplayName ?? "",
    period: formatRepresentationPeriod(r),
  };
  switch (r.pendingStep) {
    case "substituteDecision":
      return t(
        "ucet.representation.pendingSubstituteDecision",
        "Žádost o zástup čeká na potvrzení zástupcem {{name}} ({{period}}).",
        params
      );
    case "requesterConfirm":
      return t(
        "ucet.representation.pendingRequesterConfirm",
        "Zástupce {{name}} zástup přijal ({{period}}), čeká se na vaše potvrzení.",
        params
      );
    default:
      return t(
        "ucet.representation.pendingChooseSubstitute",
        "Máte rozpracovanou žádost o zástup - vyberte zástupce a termín."
      );
  }
};

/** Stav zadosti pro spravce (prehled zastupu zamestnancu). */
export const pendingRepresentationState = (
  t: TFunction,
  r: ProfileRepresentation
) => {
  switch (r.pendingStep) {
    case "substituteDecision":
      return t(
        "ucet.representation.state.substituteDecision",
        "Čeká na zástupce"
      );
    case "requesterConfirm":
      return t(
        "ucet.representation.state.requesterConfirm",
        "Čeká na potvrzení"
      );
    default:
      return t("ucet.representation.state.chooseSubstitute", "Rozpracováno");
  }
};
